// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function GridDetailPanels(_) {
  return null;
}